// @flow
import React, { Component, type Element } from 'react';

type State = {
  isActive: boolean,
};

type Props = {
  children: (handler: () => void, isActive: boolean) => Element<*>,
  isActive?: boolean,
  onToggle?: boolean => void,
};

export class Toggler extends Component<Props, State> {
  state: State = {
    isActive: this.props.isActive || false,
  };

  componentDidUpdate(prevProps: Props) {
    const { isActive } = this.props;
    if (isActive !== prevProps.isActive) {
      this.setState({
        isActive,
      });
    }
  }

  toggle = () => {
    const { onToggle } = this.props;

    this.setState(
      prevState => ({
        isActive: !prevState.isActive,
      }),
      () => {
        if (onToggle) {
          onToggle(this.state.isActive);
        }
      },
    );
  };

  render() {
    const { children } = this.props;
    const { isActive } = this.state;
    return children(this.toggle, isActive);
  }
}
